module.exports = __webpack_public_path__ + "static/media/cloud-sun-hail.a155b214.svg";